import { WithTranslation, withTranslation } from "react-i18next";
import Table from "./Table";

type Props = WithTranslation & {
  seasonHistory: Array<{
    season_name: string;
    total_points: number;
    rank: number;
  }>;
};

const EntryHistoryTable = ({ seasonHistory, t }: Props) => {
  return (
    <Table>
      <thead>
        <tr>
          <th>{t("entryHistory.season", "Season")}</th>
          <th>{t("entryHistory.points", "Points")}</th>
          <th>{t("entryHistory.Rank", "Rank")}</th>
        </tr>
      </thead>
      <tbody>
        {seasonHistory.map((sh) => (
          <tr key={sh.season_name}>
            <td>{sh.season_name}</td>
            <td>{sh.total_points}</td>
            <td>{sh.rank}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default withTranslation()(EntryHistoryTable);
